(() => {
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-fairfresh-add]');
    if (!button || button.disabled) return;
    event.preventDefault();
    const variantId = button.dataset.fairfreshAdd;
    if (!variantId) return;
    const originalLabel = button.textContent;
    button.disabled = true;
    button.textContent = '…';
    try {
      const response = await fetch(window.routes.cart_add_url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: ['cart-drawer', 'cart-icon-bubble'] }) });
      const state = await response.json();
      if (!response.ok) throw new Error(state.description || 'Cart add failed');
      document.querySelector('cart-drawer')?.renderContents(state);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'fairfresh-cart-upsell', productVariantId: Number(variantId), cartData: state });
      }
      window.dataLayer?.push({ event: 'fairfresh_add_to_cart', variant_id_added: String(variantId) });
    } catch (error) {
      console.error(error);
      button.textContent = 'Erneut versuchen';
      button.disabled = false;
      return;
    }
    button.textContent = originalLabel;
    button.disabled = false;
  });
})();
